import { FC } from 'react'
import { Draggable, Droppable } from 'react-beautiful-dnd'
import { FORM_ELEMENT_TYPES, FORM_ELEMENT_ICONS } from '@mobileConstants'
import { DragIndicator } from '@mui/icons-material'
import { Box, Paper, Typography } from '@mui/material'

export const AvailableElementsPanel: FC = () => {
  return (
    <Paper
      sx={{
        width: 280,
        flexShrink: 0,
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
      }}
    >
      <Box
        sx={{
          p: 2,
          borderBottom: theme => `1px solid ${theme.palette.divider}`,
        }}
      >
        <Typography variant='h6' gutterBottom>
          Available Elements
        </Typography>
        <Typography variant='caption' color='text.secondary'>
          Drag elements to build your form
        </Typography>
      </Box>

      <Box sx={{ flex: 1, overflow: 'auto', p: 2 }}>
        <Droppable droppableId='AVAILABLE_ELEMENTS' isDropDisabled type='ELEMENTS'>
          {provided => (
            <Box ref={provided.innerRef} {...provided.droppableProps}>
              {FORM_ELEMENT_TYPES.map((elementType, index) => (
                <Draggable
                  key={elementType.value}
                  draggableId={`NEW:${elementType.value}`}
                  index={index}
                >
                  {(providedDrag, snapshotDrag) => (
                    <Box
                      ref={providedDrag.innerRef}
                      {...providedDrag.draggableProps}
                      {...providedDrag.dragHandleProps}
                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                        py: 1.5,
                        px: 2,
                        gap: 1.5,
                        mb: 1,
                        backgroundColor: snapshotDrag.isDragging
                          ? 'primary.light'
                          : 'background.paper',
                        border: '1px solid',
                        borderColor: snapshotDrag.isDragging ? 'primary.main' : 'divider',
                        borderRadius: 1,
                        cursor: 'grab',
                        transition: 'all 0.2s',
                        '&:hover': {
                          backgroundColor: 'action.hover',
                          borderColor: 'primary.main',
                        },
                      }}
                    >
                      <DragIndicator sx={{ color: 'text.secondary', fontSize: 20 }} />
                      <Box
                        sx={{
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          color: 'primary.main',
                          mr: 0.5,
                        }}
                      >
                        {FORM_ELEMENT_ICONS[elementType.value]}
                      </Box>
                      <Typography variant='body2' fontWeight='500'>
                        {elementType.label}
                      </Typography>
                    </Box>
                  )}
                </Draggable>
              ))}
              {provided.placeholder}
            </Box>
          )}
        </Droppable>
      </Box>
    </Paper>
  )
}
